import { useCallback } from 'react';

export const useQuickCutProgress = ({ matchedBarber, setQuickCutProgress, setEstimatedArrival }) => {
  const updateQuickCutProgress = useCallback((stage) => {
    const stages = {
      searching: 20,
      matched: 40,
      barber_on_way: 60,
      barber_arrived: 80,
      cutting: 90,
      completed: 100
    };

    setQuickCutProgress(stages[stage] || 0);

    if (stage === 'barber_on_way' && matchedBarber?.distance) {
      const eta = Math.ceil(matchedBarber.distance * 2);
      setEstimatedArrival(new Date(Date.now() + eta * 60 * 1000));
    }
  }, [matchedBarber?.distance, setEstimatedArrival, setQuickCutProgress]);

  return { updateQuickCutProgress };
};
